module.exports = __webpack_public_path__ + "static/media/54d0e336cc5f377cbdd93d019adc3744.85fd3fba.mp4";